import React from 'react';
import PropTypes from 'prop-types';
import { Action, Actions, Date, Item, connectActiveItem } from 'components/list';
import fullName from 'common/utils/fullName';
import Icon from 'common/components/Icon';
import { compose, lifecycle, withState } from 'recompose';
import { connect } from 'react-redux';
import { GET, PATCH } from '../../../../utils/httpMethods';
import { withSession } from '../../../sessions';
import './Entity.scss';

const deleteEntity = async (id) => {
    if (!window.confirm('Souhaitez-vous vraiment supprimer ce réseau ?')) {
        return;
    }

    await PATCH(`/api/entities/${id}`, { body: { deleted: true } });
    document.location.href = '/admin/entity';
};

const Entity = ({ id, name, caseManager, manager, createdAt, children, displayChildren, show, isActive, middleEntityId, withEntityUsers, session }) => {
    const { isAdmin } = session;
    const isDisabled = (children && children.length > 0) || middleEntityId || withEntityUsers || !isAdmin;

    return (
        <Item
            displayActions={isActive}
            onFocus={!isActive ? () => show() : null}
            ignoreFocus
        >
            <td>{name}</td>
            <td>{manager ? fullName(manager) : ''}</td>
            <td>{caseManager ? fullName(caseManager) : ''}</td>
            <Date date={createdAt} />
            <td>
                {children && children.length > 0 && (
                /* eslint-disable-next-line */
                    <button
                        className="children-count"
                        onFocus={() => {
                            show('none');
                            displayChildren({ id, name });
                        }}
                    >
                        <span>{children.length}</span>
                        <Icon icon="chevron-down" />
                    </button>
                )}
            </td>
            <Actions>
                <Action to={`/admin/entity/${id}`} icon="pencil" text="modifier" />
                <Action onClick={() => deleteEntity(id)} icon="trash-o" text="supprimer" disabled={isDisabled} right />
            </Actions>
        </Item>
    );
};

Entity.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    caseManager: PropTypes.shape({}),
    manager: PropTypes.shape({}),
    createdAt: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
    displayChildren: PropTypes.func,
    show: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
    middleEntityId: PropTypes.string,
    withEntityUsers: PropTypes.bool,
    session: PropTypes.shape({
        isAdmin: PropTypes.bool,
    }).isRequired,
};

export default compose(
    withSession,
    connectActiveItem(
        ({ id }) => id,
        (item, { activeItem, target }) => ({ isActive: item === activeItem && 'default' === target }),
    ),
    connect((state) => (({
        entities: Object.values(state.data.entity),
    }))),
    withState('withEntityUsers', 'setWithEntityUsers', false),
    lifecycle({
        async componentDidMount() {
            const response = await GET(`/api/users/${this.props.id}`);
            const userEntity = await response.json();
            if (userEntity && userEntity.items.length > 0) {
                this.props.setWithEntityUsers(true);
            }
        },
    }),
)(Entity);
